import { render, staticRenderFns } from "./news-image.vue?vue&type=template&id=4c478a9a&scoped=true&"
import script from "./news-image.vue?vue&type=script&lang=js&"
export * from "./news-image.vue?vue&type=script&lang=js&"
import style0 from "./news-image.vue?vue&type=style&index=0&id=4c478a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c478a9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VImg,VProgressCircular})
